import { render } from "./Ueditor.vue?vue&type=template&id=c7fba7c4"
import script from "./Ueditor.vue?vue&type=script&lang=js"
export * from "./Ueditor.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__